/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import Loader from '../../../../components/Loader/Loader';
import InfoPopoverCommentsWrapper from '../../../../components/InfoPopoverCommentsWrapper';
import moment from 'moment';
import useStyles from '../../Main.style';
import InfoPopover from '../../../../components/InfoPopover/InfoPopover';
import { customSortHelper, formatToCurrency } from '../../../../utils/Helper';

const QbFieldsByCountry = ({
  reportByCell,
  reportArr,
  myCountryInvoiceArray,
  myProfitRevenue,
  financialPerformanceCountryByYear,
  dashboardComments,
  dashboardSectionText,
  onCommentUpdate,
  collectionReportData,
}) => {
  const classes = useStyles();
  const [pastDueInvoicesObject, setPastDueInvoicesObject] = useState([]);
  const [isLoaded] = useState(true);
  const [operatingIncomeObject, setOperatingIncomeObject] = useState([]);
  const [incomeBeforeTaxesObject, setIncomeBeforeTaxesObject] = useState([]);

  const fillOperatingIncome = async ({ reportByCell }) => {
    // Initialize sum of operatingIncome
    let sumOfOperatingIncome = 0;

    // Calculate sum of operatingIncome
    reportByCell.forEach((obj) => {
      if (obj?.reportPeriod.split('-')[0] == moment().year()) {
        sumOfOperatingIncome += parseFloat(obj?.operatingIncome || 0); // Adding || 0 to handle null or undefined
      }
    });
    setOperatingIncomeObject(sumOfOperatingIncome?.toFixed(2));
  };

  const fillIncomeBeforeTaxes = async ({ reportByCell }) => {
    let sumOfIncomeBeforeTaxes = 0;
    reportByCell.forEach((obj) => {
      if (obj?.reportPeriod.split('-')[0] == moment().year()) {
        sumOfIncomeBeforeTaxes += parseFloat(obj?.incomeBeforeTaxes || 0); // Adding || 0 to handle null or undefined
      }
    });
    //Ranking logic
    setIncomeBeforeTaxesObject(sumOfIncomeBeforeTaxes?.toFixed(2));
  };

  const findColumnObject = useCallback(async (obj, searchText, parentObj = null) => {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        const results = await Promise.all(
          obj.map((item) => findColumnObject(item, searchText, obj)),
        );
        return results.find((result) => result !== null);
      }
      const keys = Object.keys(obj);
      const results = await Promise.all(
        keys.map((key) => findColumnObject(obj[key], searchText, obj)),
      );
      const foundResult = results.find((result) => result !== null);
      if (foundResult) {
        return foundResult;
      }
      const foundKey = keys.find(
        (key) =>
          typeof obj[key] === 'string' && obj[key].toLowerCase() === searchText.toLowerCase(),
      );
      if (foundKey) {
        return { object: obj, parent: parentObj };
      }
    }
    return null;
  }, []);

  const findObjectBySearchText = useCallback(async (obj, searchText) => {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        const results = await Promise.all(
          obj.map((item) => findObjectBySearchText(item, searchText)),
        );
        return results.find((result) => result !== null);
      }
      const keys = Object.keys(obj);
      const results = await Promise.all(
        keys.map((key) => findObjectBySearchText(obj[key], searchText)),
      );
      const foundResult = results.find((result) => result !== null);
      if (foundResult) {
        return foundResult;
      }
      const foundKey = keys.find(
        (key) =>
          typeof obj[key] === 'string' &&
          obj[key].toLowerCase().indexOf(searchText.toLowerCase()) !== -1,
      );
      if (foundKey) {
        return { object: obj };
      }
    }
    return null;
  }, []);

  const fillPastDueTotals = useCallback(
    async (reportObj) => {
      const pastDueColumns = await findColumnObject(reportObj?.reportResult, 'Customer');

      let requiredColumnIndex31andOver = 0;
      let requiredColumnIndexCurrent = 0;
      let requiredColumnIndex1to30 = 0;
      let requiredColumnIndexOverallOutstanding = 0;

      pastDueColumns?.parent.forEach((c, i) => {
        if (c?.ColTitle?.toLowerCase() === '31 and over') {
          requiredColumnIndex31andOver = i;
        } else if (c?.ColTitle?.toLowerCase() === 'current') {
          requiredColumnIndexCurrent = i;
        } else if (c?.ColTitle?.toLowerCase() === '1 - 30') {
          requiredColumnIndex1to30 = i;
        } else if (c?.ColTitle?.toLowerCase() === 'total') {
          requiredColumnIndexOverallOutstanding = i;
        }
      });

      const pastDueInvTotalYtd = await findObjectBySearchText(
        reportObj?.reportResult,
        'GrandTotal',
      );
      const pastDueAmt =
        pastDueInvTotalYtd?.object?.Summary?.ColData[requiredColumnIndexOverallOutstanding];
      const currentAmt = pastDueInvTotalYtd?.object?.Summary?.ColData[requiredColumnIndexCurrent];
      const oneToThirtyAmt = pastDueInvTotalYtd?.object?.Summary?.ColData[requiredColumnIndex1to30];
      const thirtyAndOverAmt =
        pastDueInvTotalYtd?.object?.Summary?.ColData[requiredColumnIndex31andOver];

      setPastDueInvoicesObject((prevState) => [
        ...prevState,
        {
          pastDueTotal: pastDueAmt?.value || 0,
          country: reportObj?.country,
          current: currentAmt?.value || 0,
          oneToThirty: oneToThirtyAmt?.value || 0,
          thirtyAndOver: thirtyAndOverAmt?.value || 0,
        },
      ]);
    },
    [findColumnObject, findObjectBySearchText],
  );

  useEffect(() => {
    fillPastDueTotals(reportArr);
  }, [fillPastDueTotals, reportArr]);

  useEffect(() => {
    fillOperatingIncome({ reportByCell });
  }, []);

  useEffect(() => {
    fillIncomeBeforeTaxes({ reportByCell });
  }, []);

  return (
    <>
      {/* PROFIT COMPONENT */}
      <Box className={classes.innercontentWhite} height="100%">
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h5" noWrap>
            Invoicing - Accounting (QuickBooks & Digital Contpaqi)
          </Typography>
          <InfoPopover
            dashboardComments={dashboardComments}
            dashboardSectionText="Invoicing - Accounting (QuickBooks & Digital Contpaqi)"
            onCommentUpdate={onCommentUpdate}
          />
        </Box>
        <Box mt={1} className={classes.TableUIV2}>
          <MaterialTable
            style={{ boxShadow: 'none' }}
            isLoading={myCountryInvoiceArray.length === 0 ? true : false}
            options={{
              toolbar: false,
              draggable: false,
              paging: false,
              sorting: true,
              pageSize: 20,
              pageSizeOptions: [10, 20, 50, 100],
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'right',
              showFirstLastPageButtons: false,
              actionsColumnIndex: -100,
              emptyRowsWhenPaging: false,
            }}
            localization={{
              pagination: {
                labelRowsSelect: 'Rows',
                labelRowsPerPage: 'Rows Per Page',
              },
            }}
            title="Invoicing"
            columns={[
              {
                title: `${new Date().getFullYear()} YTD`,
                field: 'ytd',
                sorting: false,
              },
              {
                title: 'United States',
                field: 'usa',
                width: '15%',
                customSort: (a, b) => customSortHelper(a, b, 'usa1'),
              },
              {
                title: 'Mexico',
                field: 'mexico',
                width: '15%',
                customSort: (a, b) => customSortHelper(a, b, 'mexico1'),
              },
              {
                title: 'Chile',
                field: 'chile',
                width: '15%',
                customSort: (a, b) => customSortHelper(a, b, 'chile1'),
              },
              {
                title: 'Peru',
                field: 'peru',
                width: '15%',
                customSort: (a, b) => customSortHelper(a, b, 'peru1'),
              },
            ]}
            data={[
              {
                ytd: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Revenue"
                    title={dashboardSectionText}
                    onCommentUpdate={onCommentUpdate}
                  />
                ),

                usa:
                  formatToCurrency(financialPerformanceCountryByYear?.us?.revenue, classes) ==
                    'N/A' || financialPerformanceCountryByYear?.us?.revenue == 0
                    ? formatToCurrency(myProfitRevenue?.revenueValue, classes)
                    : formatToCurrency(financialPerformanceCountryByYear?.us?.revenue, classes),
                mexico: formatToCurrency(financialPerformanceCountryByYear?.mx?.revenue, classes),
                chile: formatToCurrency(financialPerformanceCountryByYear?.cl?.revenue, classes),
                peru: formatToCurrency(financialPerformanceCountryByYear?.pe?.revenue, classes),
                usa1:
                  financialPerformanceCountryByYear?.us?.revenue || myProfitRevenue?.revenueValue,
                mexico1: financialPerformanceCountryByYear?.mx?.revenue,
                chile1: financialPerformanceCountryByYear?.cl?.revenue,
                peru1: financialPerformanceCountryByYear?.pe?.revenue,
              },
              {
                ytd: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Revenue Target"
                    title={dashboardSectionText}
                    onCommentUpdate={onCommentUpdate}
                  />
                ),
                usa: formatToCurrency(myCountryInvoiceArray[6]?.usa, classes),
                mexico: formatToCurrency(myCountryInvoiceArray[6]?.mexico, classes),
                chile: formatToCurrency(myCountryInvoiceArray[6]?.chile, classes),
                peru: formatToCurrency(myCountryInvoiceArray[6]?.peru, classes),
                usa1: myCountryInvoiceArray[6]?.usa,
                mexico1: myCountryInvoiceArray[6]?.mexico,
                chile1: myCountryInvoiceArray[6]?.chile,
                peru1: myCountryInvoiceArray[6]?.peru,
              },
              {
                ytd: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Gross Profit"
                    title={dashboardSectionText}
                    onCommentUpdate={onCommentUpdate}
                  />
                ),

                usa:
                  formatToCurrency(financialPerformanceCountryByYear?.us?.grossProfit, classes) ==
                    'N/A' || financialPerformanceCountryByYear?.us?.grossProfit == 0
                    ? formatToCurrency(myProfitRevenue?.grossProftYtdValue, classes)
                    : formatToCurrency(financialPerformanceCountryByYear?.us?.grossProfit, classes),

                mexico: formatToCurrency(
                  financialPerformanceCountryByYear?.mx?.grossProfit,
                  classes,
                ),
                chile: formatToCurrency(
                  financialPerformanceCountryByYear?.cl?.grossProfit,
                  classes,
                ),
                peru: formatToCurrency(financialPerformanceCountryByYear?.pe?.grossProfit, classes),
                usa1:
                  financialPerformanceCountryByYear?.us?.grossProfit ||
                  myProfitRevenue?.grossProftYtdValue,
                mexico1: financialPerformanceCountryByYear?.mx?.grossProfit,
                chile1: financialPerformanceCountryByYear?.cl?.grossProfit,
                peru1: financialPerformanceCountryByYear?.pe?.grossProfit,
              },
              {
                ytd: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Gross Profit Target"
                    title={dashboardSectionText}
                    onCommentUpdate={onCommentUpdate}
                  />
                ),
                usa: formatToCurrency(myCountryInvoiceArray[7]?.usa, classes),
                mexico: formatToCurrency(myCountryInvoiceArray[7]?.mexico, classes),
                chile: formatToCurrency(myCountryInvoiceArray[7]?.chile, classes),
                peru: formatToCurrency(myCountryInvoiceArray[7]?.peru, classes),
                //
                usa1: myCountryInvoiceArray[7]?.usa,
                mexico1: myCountryInvoiceArray[7]?.mexico,
                chile1: myCountryInvoiceArray[7]?.chile,
                peru1: myCountryInvoiceArray[7]?.peru,
              },
              {
                ytd: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Operating Income"
                    title={dashboardSectionText}
                    onCommentUpdate={onCommentUpdate}
                  />
                ),
                // usa: format2CountryData(
                //   financialPerformanceCountryByYear?.us?.operatingIncome || operatingIncomeObject,
                //   classes,
                // ),
                usa: formatToCurrency(myProfitRevenue?.operationProfitYtdValue, classes),
                mexico: formatToCurrency(
                  financialPerformanceCountryByYear?.mx?.operatingIncome,
                  classes,
                ),
                chile: formatToCurrency(
                  financialPerformanceCountryByYear?.cl?.operatingIncome,
                  classes,
                ),
                peru: formatToCurrency(
                  financialPerformanceCountryByYear?.pe?.operatingIncome,
                  classes,
                ),
                //
                usa1: myProfitRevenue?.operationProfitYtdValue,
                mexico1: financialPerformanceCountryByYear?.mx?.operatingIncome,
                chile1: financialPerformanceCountryByYear?.cl?.operatingIncome,
                peru1: financialPerformanceCountryByYear?.pe?.operatingIncome,
              },
              {
                ytd: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Income Before Taxes"
                    title={dashboardSectionText}
                    onCommentUpdate={onCommentUpdate}
                  />
                ),
                // usa: format2CountryData(
                //   financialPerformanceCountryByYear?.us?.incomeBeforeTaxes ||
                //     incomeBeforeTaxesObject,
                //   classes,
                // ),
                usa: formatToCurrency(
                  Number(myProfitRevenue?.netIncomeYtdValue) +
                    Number(myProfitRevenue?.imcomeTaxesYtdValue),
                  classes,
                ),
                mexico: formatToCurrency(
                  financialPerformanceCountryByYear?.mx?.incomeBeforeTaxes,
                  classes,
                ),
                chile: formatToCurrency(
                  financialPerformanceCountryByYear?.cl?.incomeBeforeTaxes,
                  classes,
                ),
                peru: formatToCurrency(
                  financialPerformanceCountryByYear?.pe?.incomeBeforeTaxes,
                  classes,
                ),
                //
                usa1:
                  Number(myProfitRevenue?.netIncomeYtdValue) +
                  Number(myProfitRevenue?.imcomeTaxesYtdValue),
                mexico1: financialPerformanceCountryByYear?.mx?.incomeBeforeTaxes,
                chile1: financialPerformanceCountryByYear?.cl?.incomeBeforeTaxes,
                peru1: financialPerformanceCountryByYear?.pe?.incomeBeforeTaxes,
              },
              {
                ytd: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Current (Not Yet Due)"
                    title={dashboardSectionText}
                    onCommentUpdate={onCommentUpdate}
                  />
                ),
                usa: formatToCurrency(
                  pastDueInvoicesObject.find((c) => c?.country?.shortName.toLowerCase() === 'us')
                    ?.current || 0,
                ),
                mexico: formatToCurrency(collectionReportData?.Mexico?.currentAmount),
                chile: formatToCurrency(collectionReportData?.Chile?.currentAmount),
                peru: formatToCurrency(collectionReportData?.Peru?.currentAmount),
                //
                usa1:
                  pastDueInvoicesObject.find((c) => c?.country?.shortName.toLowerCase() === 'us')
                    ?.current || 0,
                mexico1: 'N/A',
                chile1: 'N/A',
                peru1: 'N/A',
              },
              {
                ytd: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="1 - 30 Days Past Due Amount"
                    title={dashboardSectionText}
                    onCommentUpdate={onCommentUpdate}
                  />
                ),
                usa: formatToCurrency(
                  pastDueInvoicesObject.find((c) => c?.country?.shortName.toLowerCase() === 'us')
                    ?.oneToThirty || 0,
                ),
                mexico: formatToCurrency(collectionReportData?.Mexico?.earlyPastDue),
                chile: formatToCurrency(collectionReportData?.Chile?.earlyPastDue),
                peru: formatToCurrency(collectionReportData?.Peru?.earlyPastDue),
              },
              {
                ytd: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="31+ Days Past Due amount"
                    title={dashboardSectionText}
                    onCommentUpdate={onCommentUpdate}
                  />
                ),
                usa: formatToCurrency(
                  pastDueInvoicesObject.find((c) => c?.country?.shortName.toLowerCase() === 'us')
                    ?.thirtyAndOver || 0,
                ),
                mexico: formatToCurrency(collectionReportData?.Mexico?.latePastDue),
                chile: formatToCurrency(collectionReportData?.Chile?.latePastDue),
                peru: formatToCurrency(collectionReportData?.Peru?.latePastDue),
              },
              {
                ytd: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Overall Outstanding"
                    title={dashboardSectionText}
                    onCommentUpdate={onCommentUpdate}
                  />
                ),
                usa: formatToCurrency(
                  pastDueInvoicesObject.find((c) => c?.country?.shortName.toLowerCase() === 'us')
                    ?.pastDueTotal || 0,
                ),
                mexico: formatToCurrency(collectionReportData?.Mexico?.overallOutstanding),
                chile: formatToCurrency(collectionReportData?.Chile?.overallOutstanding),
                peru: formatToCurrency(collectionReportData?.Peru?.overallOutstanding),
              },
            ]}
          />
        </Box>
      </Box>
    </>
  );
};

QbFieldsByCountry.propTypes = {
  reportByCell: PropTypes.arrayOf(PropTypes.object).isRequired,
  reportArr: PropTypes.arrayOf(PropTypes.object).isRequired,
  myCountryInvoiceArray: PropTypes.arrayOf(PropTypes.object).isRequired,
  //myProfitRevenue: PropTypes.number.isRequired,
  financialPerformanceCountryByYear: PropTypes.shape({
    us: PropTypes.shape({
      operatingIncome: PropTypes.number,
      incomeBeforeTaxes: PropTypes.number,
    }).isRequired,
  }).isRequired,
};
export default QbFieldsByCountry;
